import React from 'react';

function BotStatus({ status, uptime, onStart, onStop, onRestart, loadingAction }) {
  const formatUptime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours}h ${minutes}m ${secs}s`;
  };

  return (
    <div className="dashboard-card">
      <h2>Bot Status</h2>
      <div style={{ fontSize: '1.2rem', marginTop: '20px' }}>
        <span className={`status-indicator status-${status}`}></span>
        <span style={{ textTransform: 'capitalize' }}>{status}</span>
      </div>
      {status === 'running' && (
        <div style={{ marginTop: '10px', color: '#7f8c8d' }}>
          Uptime: {formatUptime(uptime)}
        </div>
      )}
      <div className="button-group">
        <button 
          className={`btn-start ${loadingAction === 'start' ? 'loading' : ''}`}
          onClick={onStart}
          disabled={status === 'running' || loadingAction !== null}
        >
          {loadingAction === 'start' ? (
            <>
              <span className="button-text">Starting</span>
              <span className="loading-dots">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </>
          ) : (
            <span className="button-text">Start</span>
          )}
        </button>
        <button 
          className={`btn-stop ${loadingAction === 'stop' ? 'loading' : ''}`}
          onClick={onStop}
          disabled={status === 'stopped' || loadingAction !== null}
        >
          {loadingAction === 'stop' ? (
            <>
              <span className="button-text">Stopping</span>
              <span className="loading-dots">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </>
          ) : (
            <span className="button-text">Stop</span>
          )}
        </button>
        <button 
          className={`btn-restart ${loadingAction === 'restart' ? 'loading' : ''}`}
          onClick={onRestart}
          disabled={status === 'stopped' || loadingAction !== null}
        >
          {loadingAction === 'restart' ? (
            <>
              <span className="button-text">Restarting</span>
              <span className="loading-dots">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </>
          ) : (
            <span className="button-text">Restart</span>
          )}
        </button>
      </div>
    </div>
  );
}

export default BotStatus;